<template>

  <div class="video">
   <!-- <button class="playpause" @click="play" v-show="paused">
      <img src="/static/img/play-btn.svg" height="50px" width="50px">
    </button>-->
<!--
    <button class="playpause2" @click="pause" v-show="playing"></button>
-->
    <video disablePictureInPicture controlsList="nodownload"
           class="videoElement" ref="videoElement" @canplay="updatePaused" @playing="updatePaused" @pause="updatePaused"
           :poster="cover" playsinline controls>
      <source v-for="file in files" :key="file.type" :src="file.url" :type="file.type">
    </video>
  </div>
</template>

<script>

export default {
  name: 'video-player',
  props: ['cover', 'files'],
  data() {
    return {
      paused: null,
    };
  },
  computed: {
    playing() {
      return !this.$data.paused;
    },
  },
  methods: {
    updatePaused(event) {
      if (this.$refs.videoElement)
        this.$data.paused = this.$refs.videoElement.paused;
    },
    play() {
      this.$refs.videoElement.play();
    },
    pause() {
      this.$refs.videoElement.pause();
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/home/part/video-player.vue